import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ReactGA from 'react-ga4';
import { useParams } from 'react-router-dom';

import LessonPage from 'components/LessonPage/LessonPage';

const Lesson = () => {
  const { idCourse, idLesson } = useParams();
  const dataAcademy = useSelector(state => state.academyInfo);

  useEffect(() => {
    ReactGA.initialize(
      [
        {
          trackingId: 'G-5883QCZJX8',
          gaOptions: {
            name: 'trackerMayahii'
          }
        },
        {
          trackingId: `${dataAcademy.data.analitycs}`,
          gaOptions: { name: 'trackerUser' }
        }
      ],
      { debug: false }
    );

    ReactGA.send({
      hitType: 'pageview',
      page: `/${dataAcademy.data.shortName}/f/${idCourse}/${idLesson}`,
      title: `/${dataAcademy.data.shortName}/f/${idCourse}/${idLesson}`
    });
  }, [dataAcademy]);

  return <LessonPage idCourse={idCourse} idLesson={idLesson} />;
};

export default Lesson;
